import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const schoolInstance = axios.create({
	baseURL: config.api,
	headers: {
		'Content-Type': 'application/json'
	}
});

class SchoolApi {

	static SchoolInsert(payload) {
		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolInstance.post('/school', payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}

	static SchoolUpdate(payload, id) {
		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolInstance.patch(`/school/${id}`, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}

	static SchoolList() {
		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolInstance.get('/school?showMore=true')
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}

	static SchoolDelete(id) {
		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolInstance.delete(`/school/${id}`)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}

	static AverageScore(schoolId, schoolYear, name) {

		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		var queryString = "";
		if (schoolId.length > 0) {
			queryString = `?schoolId=${schoolId}`;
		}
		if (schoolYear.length > 0) {
			if (queryString.length > 0) {
				queryString += `&schoolYear=${schoolYear}`;
			} else {
				queryString += `?schoolYear=${schoolYear}`;
			}
		}

		if (name.length > 0) {
			if (queryString.length > 0) {
				queryString += `&className=${name}`;
			} else {
				queryString += `?className=${name}`;
			}
		}

		if (queryString.length > 0) {
			return schoolInstance.get(`/student/getAverageScore${queryString}`)
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					throw (error);
				});
		} else {
			return schoolInstance.get(`/student/getAverageScore`)
				.then(function (response) {
					return response.data;
				})
				.catch(function (error) {
					throw (error);
				});
		}
	}

	static BrowseCount(year, month, day) {
		schoolInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolInstance.get(`/record?year=${year}&month=${month}&day=${day}`)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});

	}

}

export default SchoolApi;


